import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LayoutComponent} from './components/layout/layout.component';
import {ContainerComponent} from './components/container/container.component';
import {ElementComponent} from './components/element/element.component';

@NgModule({
    imports: [CommonModule],
    declarations: [ContainerComponent, LayoutComponent, ElementComponent],
    exports: [ContainerComponent, LayoutComponent, ElementComponent]
})
export class LayoutGridModule {}
